<template>
    <div>
        <div v-if="rows && rows.length > 0">
            <table class="table">
                <component :is="headerTemplateSelection" :header="header" :actions="actions" :selected="selectedAll" v-on:selectAll="selectAllMethod"></component>
                <component :is="bodyTemplateSelection" :header="header" :body="body" :rows="rows" :actions="actions" :selected="selectedAll"></component>
                <template v-if="footerTitles && footerRow"> <!-- sorry Sergio, quick and dirty way to test the totals row -->
                    <component :is="headerTemplateSelection" :header="footerTitles" :actions="actions" :selected="selectedAll" @selectAll="selectedAll = $event"></component>
                    <component :is="bodyTemplateSelection" :header="header" :body="body" :rows="footerRow" :actions="actions" :selected="selectedAll"></component>
                </template>
            </table>
        </div>
        <div v-else-if="showNoDataMessage" class="empty-panel">No data available.</div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            selectedAll: false
        }
    },
    props: {
        header: Object,
        body: Object,
        rows: Array,
        footerTitles: Object,
        footerRow: Array,
        showNoDataMessage:{
            default: true
        },
        actions: {
            type: Object,
            default: function() {
                return {};
            }
        }
    },
    computed: {
        headerTemplateSelection: function () {
            return this.triggerPath(this.header, './baseHeader');
        },
        bodyTemplateSelection: function () {
            return this.triggerPath(this.body, './baseBody');
        }
    },
    methods: {
        triggerPath: function (prop, baseTemplate) {
            var path = (prop && prop.template !== undefined && prop.template) ? prop.template : baseTemplate;

            if (path === '') {
                return;
            }

            try {
                return require(`${path}`);
            }
            catch (e) {
                console.log('Unable to find (' + path + ') for this automated list');
            }
        },
        selectAllMethod: function(status){
            console.log('selectAll', status);
            this.header.selection.event(status);
        }
    }
}
</script>



// WEBPACK FOOTER //
// baseList.vue?0773aea0